import React from "react";
import PropTypes from "prop-types";

import SquareGrid from "icons/SquareGrid";

import { UploadsGridContainer } from "./styles";

const UploadsGrid = ({ gridItemContent, numberOfColumns, gridSpacingSize }) => (
    <UploadsGridContainer>
        <SquareGrid
            gridItemContent={gridItemContent}
            numberOfColumns={numberOfColumns}
            gridSpacingSize={gridSpacingSize}
        />
    </UploadsGridContainer>
);

UploadsGrid.propTypes = {
    gridItemContent: PropTypes.arrayOf(PropTypes.object).isRequired,
    numberOfColumns: PropTypes.number.isRequired,
    gridSpacingSize: PropTypes.string.isRequired
};

export default UploadsGrid;
